import { css, Theme } from '@emotion/react';
import styled from '@emotion/styled';
import * as React from 'react';
import { Link } from 'react-router';
import { MainMenuItems } from '../../../MainMenuItems';
import { HEADER_GAP } from '../../../vars';
import { MenuWidget } from '../../Menu/MenuWidget';
import type { HeaderWidgetProps } from './HeaderWidget';
import { AlgoliaSearchWidget } from './AlgoliaSearchWidget';
import { SignInLink, StartBuildingLink, StatusPageLink, ToggleThemeButton } from './SharedButtons';

export const DesktopHeaderWidget: React.FC<HeaderWidgetProps> = (props) => {
  return (
    <>
      <MenuWidget items={MainMenuItems} />
      <S.Search />
      <S.Menu>
        <S.StartBuilding />
        <ToggleThemeButton toggleTheme={props.toggleTheme} dark={props.dark} />
        <StatusPageLink />
        <S.SignIn />
      </S.Menu>
    </>
  );
};

namespace S {
  const LinkCss = (theme: Theme) => css`
    text-decoration: none;
    color: ${theme.header.textColor};
    opacity: 0.7;
    font-size: 14px;
    min-height: 38px;
    line-height: 1.2;
    &:hover {
      opacity: 1;
    }
  `;

  export const SignIn = styled(SignInLink)`
    ${(p) => LinkCss(p.theme)};
  `;

  export const StartBuilding = styled(StartBuildingLink)``;

  export const Menu = styled.div`
    display: flex;
    align-items: center;
    white-space: nowrap;
    flex-shrink: 0;
    flex-basis: auto;
    gap: ${HEADER_GAP}px;
  `;

  export const Search = styled(AlgoliaSearchWidget)`
    flex-shrink: 0;
  `;
}
